import { combineReducers } from "redux";
import { IPInfoReducer } from "./ipAPI";

export const reducers = combineReducers({ IPInfo: IPInfoReducer });
